import React from 'react';
import { Tag } from 'antd';
import { arrComparer, removeDupes } from '../../../../api/util';
import { fetchJsData } from '../../../../api';
import { isArray } from 'lodash';

export const newApps = (leng) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'current_name',
            key: 'current_name',
            fixed: 'left',
            sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
            // responsive: ["sm"],
            width: '18%',
        },
        {
            title: 'Category',
            dataIndex: 'category_name',
            key: 'category_name',
            fixed: 'left',
            sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
            // responsive: ["sm"],
            width: '18%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Activity',
            dataIndex: 'activity_name',
            key: 'activity_name',
            fixed: 'left',
            sorter: (a, b) => (a.activity_name ? a.activity_name.localeCompare(b.activity_name) : 1),
            // responsive: ["sm"],
            width: '27%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Domain',
            dataIndex: 'domain_name',
            key: 'domain_name',
            fixed: 'left',
            sorter: (a, b) => (a.domain_name ? a.domain_name.localeCompare(b.domain_name) : 1),
            // responsive: ["sm"],
            width: '27%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Connector Type',
            dataIndex: 'connector_type',
            key: 'connector_type',
            fixed: 'left',
            sorter: (a, b) => (a.connector_type ? a.connector_type.localeCompare(b.connector_type) : 1),
            // responsive: ["sm"],
            width: '10%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
    ];
};

export const modApps = (leng) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'current_name',
            key: 'current_name',
            fixed: 'left',
            sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
            // responsive: ["sm"],
            width: '25%',
        },
        {
            title: 'Category',
            dataIndex: 'category_name',
            key: 'category_name',
            fixed: 'left',
            sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
            // responsive: ["sm"],
            width: '13%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Activity Added',
            dataIndex: 'actAdded',
            key: 'actAdded',
            fixed: 'left',
            // responsive: ["sm"],
            width: '13%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Activity Removed',
            dataIndex: 'actRemoved',
            key: 'actRemoved',
            fixed: 'left',
            // responsive: ["sm"],
            width: '13%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Domain Added',
            dataIndex: 'domAdded',
            key: 'domAdded',
            fixed: 'left',
            // responsive: ["sm"],
            width: '21%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Domain Removed',
            dataIndex: 'domRemoved',
            key: 'domRemoved',
            fixed: 'left',
            // responsive: ["sm"],
            width: '20%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Connector Type',
            dataIndex: 'connector_type',
            key: 'connector_type',
            fixed: 'left',
            sorter: (a, b) => (a.connector_type ? a.connector_type.localeCompare(b.connector_type) : 1),
            // responsive: ["sm"],
            width: '10%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
    ];
};

export const remApps = (leng) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'current_name',
            key: 'current_name',
            fixed: 'left',
            sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
            // responsive: ["sm"],
            width: '50%',
        },
        {
            title: 'Connector Type',
            dataIndex: 'connector_type',
            key: 'connector_type',
            fixed: 'left',
            sorter: (a, b) => (a.connector_type ? a.connector_type.localeCompare(b.connector_type) : 1),
            // responsive: ["sm"],
            width: '20%',
            render: (text) => {
                return <>{isArray(text) ? text.join(', ') : text}</>;
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            sorter: (a, b) => (a.action ? a.action.localeCompare(b.action) : 1),
            // responsive: ["sm"],
            width: '30%',
        },
    ];
};

export const fetchUserSearch = async (rel, prevRel, sel, modVal) => {
    try {
        const start = Date.now();
        const modData = modVal;
        // extract release info
        let newData = modData;

        const millis = Date.now() - start;

        if (sel.toUpperCase() === 'ADDED') {
            const addData = await fetchJsData({
                type: 'fetch',
                qry: 'fetDomTabByAppId',
                firstVal: 'snapshot_v' + rel + '_0_0',
                secondVal: 'snapshot_v' + rel + '_0_0',
                thirdVal: 'snapshot_v' + rel + '_0_0',
                fourthVal: ['R-' + rel],
                // fourthVal: modData.filter((x) => x.action.toUpperCase() == ‘ADDED’).map((y) => y.application_id).length > 0
                //     ? modData.filter((x) => x.action.toUpperCase() == ‘ADDED’).map((y) => y.application_id)
                //     : 0,
            });

            newData = addData['data'];
            // newData = modData.filter((x) => x.action.toUpperCase() === 'ADDED');
            // .map((item) => {
            //     const item2 = addData['data'].find((i2) => i2.application_id === item.application_id);
            //     return item2 ? { ...item, ...item2 } : item;
            // });
        }

        if (sel.toUpperCase() === 'REMOVED') {
            const remData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConRelActsRem',
                firstVal: 'snapshot_v' + (rel - 1) + '_0_0',
                secondVal: ['R-' + rel],
            });

            newData = remData['data'];
        }
        // modified
        if (sel.toUpperCase() === 'MODIFIED') {
            const modData = await fetchJsData({
                type: 'fetch',
                qry: 'fetActDom',
                firstVal: 'snapshot_v' + rel + '_0_0',
                secondVal: 'snapshot_v' + rel + '_0_0',
                thirdVal: 'snapshot_v' + rel + '_0_0',
                fourthVal: 'R-' + rel,
            });
            newData = modData['data'];
        }

        return { success: 1, data: newData };
    } catch (error) {
        console.error(error);
        return '';
    }
};

export const tabPageCss = {
    padding: '0',
    marginBottom: '0',
};

export const cardCss = { padding: '0', borderStyle: 'hidden' };
